
export default {
  name: "SmallText",

  props: { slice: { type: Object, required: true } },
};
